<template>
  <el-submenu :index="subMenu.id">
    <template slot="title">
      <em :class="subMenu.icon"></em>
      <span>{{ $t(subMenu.title) }}</span>
    </template>
    <template v-for="menu in subMenu.children">
      <child-menu
        v-if="isVisible(menu) && hasChildren(menu)"
        :subMenu="menu"
        :key="menu.id"
        :index="menu.id"
      ></child-menu>
      <el-menu-item v-else-if="isVisible(menu) && menu.click" :key="menu.id" :index="menu.id">
        <div @click="menu.click" class="menu-class">
          <em :class="menu.icon"></em>
          <span>{{ $t(menu.title) }}</span>
        </div>
      </el-menu-item>
      <el-menu-item v-else-if="isVisible(menu) && menu.href" :key="menu.id" :index="menu.id">
        <a :href="menu.href" target="_blank" class="menu-class">
          <em :class="menu.icon"></em>
          <span>{{ $t(menu.title) }}</span>
        </a>
      </el-menu-item>
      <el-menu-item
        v-else-if="isVisible(menu) && menu.route"
        :key="menu.id"
        :index="menu.route.path || menu.id"
        :route="menu.route"
      >
        <div class="menu-class">
          <em :class="menu.icon"></em>
          <span>{{ $t(menu.title) }}</span>
        </div>
      </el-menu-item>
    </template>
  </el-submenu>
</template>

<script>
export default {
  name: 'ChildMenu',
  props: {
    subMenu: Object
  },
  computed: {
    authMenu() {
      return this.$store.state.admin.authMenu;
    }
  },
  methods: {
    isVisible(menu) {
      return this.authMenu[menu.code] && !menu.hidden;
    },
    hasChildren(menu) {
      return menu.children && menu.children.length > 0;
    }
  }
};
</script>
